import React, { useEffect, useState } from 'react';
import { Heart, HeartOutline } from 'react-ionicons';
import { useLocation } from 'react-router-dom';
import PlayButtons from '../../Buttons/PlayButtons';
import { PlayerBar } from '../../Containers/Containers';
import { Avatar } from './../../Avatars/Avatar';
import VolumeSlider from './../Volume/VolumeSlider';
import displayStationInitials from '../../../utils/functions/displayInitials';
import { useDispatch, useSelector } from 'react-redux';
import * as localForage from 'localforage';
import {
  removeFromFavorites,
  addToFavourites,
  updateFavoriteByIDtoTrue,
  updateFavoriteByIDtoFalse,
} from '../../../store/features/stationSlice';
import { setFavouriteTo } from '../../../store/features/playerSlice';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmModal from '../../Modal/Modal';
import { setMenuOpenedState } from '../../../store/features/adminSlice';

/**
 * returns the PlayerBarContainer which holds the player logic and volume.
 * @example <PlayerBarContainer∏ />
 * @param {station} station
 * @returns  {void}
 */
const PlayerBarContainer = () => {
  /**
   *  calls the current station to pass it to the playerbar
   */
  const station = useSelector((state) => state.player.currentStation);
  const isFirstLoad = useSelector((state) => state.player.firstLoad);
  const { provinceIdMap } = useSelector((state) => state.stations);

  let location = useLocation();
  const dispatch = useDispatch();
  const [showPlayerBar, setShowPlayerBar] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const favouriteStorage = localForage.createInstance({
    name: 'favorites',
  });

  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];
    currentPathName.toLowerCase() === 'editar' ||
    currentPathName.toLowerCase() === 'gestion' ||
    currentPathName.toLowerCase() === 'login' ||
    currentPathName.toLowerCase() === 'acerca-de-aplicacion' ||
    currentPathName.toLowerCase() === 'politicas-de-privacidad' ||
    currentPathName.toLowerCase() === 'terminos-de-uso' ||
    currentPathName.toLowerCase().includes('manual') ||
    currentPathName.toLowerCase().includes('agregar')
      ? setShowPlayerBar(false)
      : setShowPlayerBar(true);
  }, [location]);

  useEffect(() => {
    if (isFirstLoad !== undefined) {
      setFirstLoad(isFirstLoad);
    }
  }, [isFirstLoad]);
  /**
   * returns a Heart icon which is either filled or outline depening on the status of the station.
   * @returns {void}
   */

  const addToStorageFavorites = async (stationToSave) => {
    let data = (await favouriteStorage.getItem('favs')) ?? [];
    let breakFunction = false;
    if (data.length) {
      data.forEach((station) => {
        if (station.Id === stationToSave.Id) {
          breakFunction = true;
          return;
        }
      });
      if (breakFunction) {
        return;
      }
    }
    await favouriteStorage.setItem('favs', [...data, stationToSave]);
  };

  const removeFromStorageFavorites = async (stationToRemove) => {
    let data = (await favouriteStorage.getItem('favs')) ?? [];
    let stationIndex;
    if (data.length) {
      data.forEach((station, index) => {
        if (station.Id === stationToRemove.Id) {
          stationIndex = index;
        }
      });
      data.splice(stationIndex, 1);
    }
    await favouriteStorage.setItem('favs', data);
    data = await favouriteStorage.getItem('favs');
  };

  const toggleFavourites = async () => {
    if (station.Favorite) {
      await confirmAlert({
        customUI: ({ onClose }) => {
          const clickYes = async () => {
            await dispatch(removeFromFavorites(station));
            await removeFromStorageFavorites(station);
            dispatch(setFavouriteTo(false));
            dispatch(updateFavoriteByIDtoFalse(station));
            onClose();
          };
          return (
            <ConfirmModal
              title={'Remover de favoritos'}
              text={'¿Seguro que quieres eliminar esta emisora de favoritos?'}
              accept={false}
              onClose={onClose}
              onClick={clickYes}
            />
          );
        },
      });
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          const clickYes = async () => {
            await dispatch(addToFavourites(station));
            await addToStorageFavorites(station);
            dispatch(setFavouriteTo(true));
            dispatch(updateFavoriteByIDtoTrue(station));
            onClose();
          };
          return (
            <ConfirmModal
              title={'Agregar a favoritos'}
              text={'¿Seguro que quieres agregar esta emisora a favoritos?'}
              onClose={onClose}
              onClick={clickYes}
            />
          );
        },
      });
    }
  };

  return (
    <PlayerBar
      onClick={() => dispatch(setMenuOpenedState(false))}
      className={firstLoad ? 'stayDown' : 'goUp'}
      style={{ display: showPlayerBar ? '' : 'none' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Avatar
          style={{
            borderColor: '#fff',
            color: '#fff',
            marginLeft: 'auto',
            fontSize: '1.5rem',
            minHeight: '50px',
            minWidth: '50px',
            position: 'absolute',
            left: 25,
          }}>
          {displayStationInitials(station.Name)}
        </Avatar>
        <div
          style={{
            flexDirection: 'column',
            marginRight: 'auto',
            position: 'absolute',
            left: 85,
          }}>
          <p
            style={{
              fontSize: '13px',
              margin: '0',
              opacity: '1 !important',
              color: '#fff',
              fontWeight: '600',
            }}>
            {station.Name}
          </p>
          <p
            style={{
              fontSize: '12px',
              margin: '0',
              opacity: '1 !important',
              color: '#fff',
            }}>
            {provinceIdMap[station.PlaceId]?.Name}
          </p>
        </div>
      </div>
      <PlayButtons />
      {station.Favorite ? (
        <div
          onClick={toggleFavourites}
          style={{
            width: '30px',
            marginLeft: 'auto',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'absolute',
            right: 139,
            bottom: 26,
          }}>
          <Heart
            height="23px"
            width="23px"
            style={{ display: 'block' }}
            color={'#fff'}
          />
        </div>
      ) : (
        <div
          onClick={toggleFavourites}
          style={{
            width: '30px',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'absolute',
            right: 139,
            bottom: 26,
          }}>
          <HeartOutline
            height="23px"
            width="23px"
            style={{ display: 'block' }}
            color={'#fff'}
          />
        </div>
      )}
      <VolumeSlider />
    </PlayerBar>
  );
};

export default PlayerBarContainer;
